import { getCdnUrl, getImageUrl, getVideoUrl, getFontUrl } from '@/utils/cdn.js';

export default {
  methods: {
    /**
     * 获取CDN资源路径
     * @param {string} path - 资源路径
     * @returns {string} CDN完整路径
     */
    $cdn(path) {
      return getCdnUrl(path);
    },
    
    /**
     * 获取图片CDN路径
     * @param {string} imagePath - 图片路径
     * @returns {string} 图片CDN完整路径
     */
    $cdnImage(imagePath) {
      return getImageUrl(imagePath);
    },
    
    /**
     * 获取视频CDN路径
     * @param {string} videoPath - 视频路径
     * @returns {string} 视频CDN完整路径
     */
    $cdnVideo(videoPath) {
      return getVideoUrl(videoPath);
    },
    
    /**
     * 获取字体CDN路径
     * @param {string} fontPath - 字体路径
     * @returns {string} 字体CDN完整路径
     */
    $cdnFont(fontPath) {
      return getFontUrl(fontPath);
    },
    
    /**
     * 处理require的图片路径
     * @param {string} path - 图片路径
     * @returns {string} 处理后的路径
     */
    $cdnRequire(path) {
      // 排除Element UI相关资源
      if (path.includes('element-ui') || path.includes('theme-chalk')) {
        return require(path);
      }
      
      if (process.env.NODE_ENV === 'production') {
        // 生产环境使用CDN
        return getCdnUrl(path);
      } else {
        // 开发环境使用require
        return require(path);
      }
    }
  }
};